<ng-container *ngIf="(loading$ | async) === false; else loadingTemplate">
  <div class="grid">
    <div class="col-12">
      <p-card>
        <div class="p-fluid">
          <div class="field">
            <label class="font-medium required-field">Компания</label>
            <crm-single-select
              [options]="companies"
              [(selectedItem)]="exclusion.company"
              [class]="errors?.company ? 'ng-invalid ng-dirty' : ''"
              [styleClass]="errors?.company ? 'ng-invalid ng-dirty' : ''"
              appendTo="body">
            </crm-single-select>
            <small
              *ngIf="errors?.company"
              class="p-error">
              {{ errors.company | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Контрагент</label>
            <crm-contragent-auto-complete
              [(selectedContragent)]="exclusion.contragent"
              [customSearch]="false"
              [isError]="$any(errors?.contragent)"
              appendTo="body">
            </crm-contragent-auto-complete>
            <small
              *ngIf="errors?.contragent"
              class="p-error">
              {{ errors.contragent | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium required-field">Сумма</label>
            <p-inputNumber
              [(ngModel)]="exclusion.amount"
              [ngClass]="{ 'ng-invalid ng-dirty': errors?.amount }"></p-inputNumber>
            <small
              *ngIf="errors?.amount"
              class="p-error">
              {{ errors.amount | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Дата отсрочки</label>
            <crm-datepicker
              [(value)]="exclusion.defermentGrantedUntil"
              [inputStyleClass]="errors?.defermentGrantedUntil ? 'ng-invalid ng-dirty' : ''"
              (valueChange)="delayDateMessage()"
              appendTo="body"></crm-datepicker>
            <small
              *ngIf="errors?.defermentGrantedUntil"
              class="p-error">
              {{ errors.defermentGrantedUntil | join }}
            </small>
          </div>

          <div class="field">
            <label class="font-medium">Комментарий</label>
            <crm-editor
              [(value)]="exclusion.commentary"
              height="110px"></crm-editor>
            <small
              *ngIf="errors?.commentary"
              class="p-error"
              >{{ errors.commentary | join }}</small
            >
          </div>
          <div class="flex align-items-center justify-content-between">
            <crm-file-uploader
              label="Файл"
              (filesUploaded)="exclusion.file = $event[0]"></crm-file-uploader>
            <small
              *ngIf="errors?.file"
              class="p-error">
              {{ errors.file | join }}
            </small>
            <div
              *ngIf="exclusion.file"
              class="flex align-items-center">
              <crm-document-link [file]="exclusion.file"></crm-document-link>
              <button
                pButton
                type="button"
                icon="pi pi-times"
                class="p-button-rounded p-button-danger p-button-text ml-3"
                (click)="exclusion.file = null"></button>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <div
      *ngIf="formStoreService.getState.forms[this.index]?.isEdit"
      class="col-12 mt-3">
      <crm-exclusion-history [index]="index"></crm-exclusion-history>
    </div>
  </div>

  <div class="mt-3">
    <div class="flex flex-wrap justify-content-between">
      <div>
        <button
          pButton
          [label]="saveButtonLabel"
          class="p-button-success mr-2"
          (click)="saveExclusion()"></button>
      </div>
      <button
        *ngIf="(form$ | async)?.isShowDelete"
        pButton
        label="Удалить"
        class="p-button-danger p-button-text"
        (click)="deleteExclusion()"></button>
    </div>
  </div>
</ng-container>

<ng-template #loadingTemplate>
  <crm-spinner></crm-spinner>
</ng-template>
